import { PublicKey } from "@solana/web3.js";

export const TULIP_FARM_PROGRAM_ID = new PublicKey("Bt2WPMmbwHPk36i4CRucNDyLcmoGdC7xEdrVuxgJaNE6");
